import { FormSelect } from "react-bootstrap";
import { LayerType } from "../../constant/LayerType";
import { useEffect, useState } from "react";
import { useLayerService } from "../../hooks";

interface LayerDropdownProps {
  value?: LayerType;
  onChange: (event: React.ChangeEvent<any>) => void;
}

const LayerDropdown = ({ value, onChange }: LayerDropdownProps) => {
  const [layerOptions, setLayerOptions] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);
  const layerService = useLayerService();

  useEffect(() => {
    layerService
      .ListAll()
      .then((layers) => {
        setLayerOptions(
          layers.map((layer) => {
            return {
              label: layer.displayName,
              value: layer.name,
            };
          }),
        );
      })
      .catch(() => {});
  }, [layerService]);

  return (
    <FormSelect value={value} onChange={onChange} name="layer">
      <option value="">
        {layerOptions ? "Select a layer" : "Loading options..."}
      </option>
      {layerOptions.map((layerOption: any, index: number) => (
        <option key={index} value={layerOption.value}>
          {layerOption.label}
        </option>
      ))}
    </FormSelect>
  );
};

export default LayerDropdown;
